"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./controls"));
__export(require("./formats"));
__export(require("./interactions"));
__export(require("./layers"));
__export(require("./sources"));
__export(require("./styles"));
__export(require("./attribution.component"));
__export(require("./attributions.component"));
__export(require("./content.component"));
__export(require("./coordinate.component"));
__export(require("./feature.component"));
__export(require("./geometry.components"));
__export(require("./graticule.component"));
__export(require("./map.component"));
__export(require("./overlay.component"));
__export(require("./tilegrid.component"));
__export(require("./tilegridwmts.component"));
__export(require("./view.component"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-openlayers/dist/components/index.js
// module id = 590
// module chunks = 3